import type { Template } from '@/types/template';

/**
 * Templates are owned by the company group; a company can override one, and the pickers show the
 * override in place of its parent. Configuration (a customer's statement template, a strategy
 * stage) always stores the group-level id, so matching a stored id against a picker row has to
 * accept either the row itself or the parent it overrides.
 */
export function logicalTemplateId(template: Template): string {
  return template.logicalTemplateId ?? template.sourceTemplateId ?? template.id;
}

/** Finds the template row a stored configuration id refers to in the current company. */
export function findTemplateByStoredId(
  templates: readonly Template[],
  storedTemplateId: string | undefined,
): Template | undefined {
  return storedTemplateId
    ? templates.find((x) => x.id === storedTemplateId || logicalTemplateId(x) === storedTemplateId)
    : undefined;
}
